export default __webpack_public_path__ + "static/media/report-active.c1193522.svg";